define('core/config/urls',[], function () {
    'use strict';
    return {
        jester: 'https://referrer.' + window.document.location.host + '/juggler',
        cdn: undefined,
    };
});

